module.exports = __webpack_public_path__ + "img/FOOTER_LINKS_SOCIAIS.133e787b.png";